import { NgModule, Component, ViewChild, enableProdMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { HomeRoutes } from './home.routing';
import { LandingComponent } from '../home/landing/landing.component';
import { UprofileComponent } from '../home/uprofile/uprofile.component';
import { VprofileComponent } from './vprofile/vprofile.component';
import { ChallengeForumComponent } from './challenge-forum/challenge-forum.component';
import { MyAttendanceComponent } from './my-attendance/my-attendance.component';
import { ReportComponent } from './report/report.component';
import { AddFolderComponent } from './add-folder/add-folder.component';
import { PageComponent } from './page/page.component';
import { UnotificationComponent } from './uprofile/unotification/unotification.component';
import { UannouncementComponent } from './uprofile/uannouncement/uannouncement.component';
import { UcalendarComponent } from './uprofile/ucalendar/ucalendar.component';
import { CalendarModule, CalendarDateFormatter } from 'angular-calendar';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { DragulaModule } from 'ng2-dragula/ng2-dragula';
import { ACalendarComponent } from './my-attendance/a-calendar/a-calendar.component';
import { ForumComponent } from './forum/forum.component';

import { sanitizeHtmlPipe } from './sanitize-html.pipe';
import { FileUploadModule } from 'ng2-file-upload';
import { ForumdetailComponent } from './forumdetail/forumdetail.component';
import { RightSidebarComponent } from './right-sidebar/right-sidebar.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { AnnouncementlistComponent } from './announcementlist/announcementlist.component';
import { FollowerlistComponent } from './right-sidebar/followerlist/followerlist.component';
import { TopicdetailComponent } from './topicdetail/topicdetail.component';
import { RightSidebar2Component } from './right-sidebar2/right-sidebar2.component';
import { FreedownloadComponent } from './freedownload/freedownload.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TagInputModule } from 'ngx-chips';
import { VpgComponent } from './vpg/vpg.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DxRangeSliderModule, DxNumberBoxModule } from 'devextreme-angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { VpgdetailComponent } from './vpgdetail/vpgdetail.component';
import { AgmCoreModule, MapsAPILoader,GoogleMapsAPIWrapper } from '@agm/core';
import { VerificationComponent } from './verification/verification.component';
import { PopulartopicComponent } from './populartopic/populartopic.component';
import { TrandingtopicComponent } from './trandingtopic/trandingtopic.component';
import { BlogComponent } from './blog/blog.component';
import { BloglistComponent } from './bloglist/bloglist.component';
import { GroupComponent } from './group/group.component';
import { GroupRightSidebarComponent } from './group-right-sidebar/group-right-sidebar.component';
import { UserinfoComponent } from './userinfo/userinfo.component';
import { GroupdetailComponent } from './groupdetail/groupdetail.component';
import { VjobComponent } from './vjob/vjob.component';
import { VjobdetailComponent } from './vjobdetail/vjobdetail.component';
import { DiscoverpeopleComponent } from './discoverpeople/discoverpeople.component';

import { BarRatingModule } from "ngx-bar-rating";
import { AdvertisementForumComponent } from './advertisement-forum/advertisement-forum.component';
import { ForumaddComponent } from './forumadd/forumadd.component';
import { TrandingpgComponent } from './trandingpg/trandingpg.component';
import { ExamsolutionComponent } from './examsolution/examsolution.component';
import { UserBookmarksComponent } from './user-bookmarks/user-bookmarks.component';
import { TestingComponent } from './testing/testing.component';
import { JwSocialButtonsModule } from 'jw-angular-social-buttons';
import { MmetatagComponent } from './mmetatag/mmetatag.component';
import { ProfileComponent } from './profile/profile.component';
import { OtopicdetailComponent } from './otopicdetail/otopicdetail.component';
import { RankPredictorComponent } from './rank-predictor/rank-predictor.component';
import { SetnewpasswordComponent } from './setnewpassword/setnewpassword.component';
import { VfaqComponent } from './vfaq/vfaq.component';
import { ProfileHeadComponent } from './profile-head/profile-head.component';
import { TopicFollowComponent } from './topic-follow/topic-follow.component';
import { FollowersComponent } from './followers/followers.component';
import { FollowingComponent } from './following/following.component';

import { PackagelistComponent } from './packagelist/packagelist.component';
import { PackagedetailComponent } from './packagedetail/packagedetail.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { StudentPaymentFormComponent } from './student-payment-form/student-payment-form.component';
import { MypackagesComponent } from './mypackages/mypackages.component';
import { MypackagedetailComponent } from './mypackagedetail/mypackagedetail.component';
import { PackagedataComponent } from './packagedata/packagedata.component';
import { PaymentComponent } from './payment/payment.component';
import { PackageinvoiceComponent } from './packageinvoice/packageinvoice.component';
import { TimelineComponent } from './timeline/timeline.component';
import { EvaluateAnswerSheetComponent } from './evaluate-answer-sheet/evaluate-answer-sheet.component';
import { PackageinvoicelistComponent } from './packageinvoicelist/packageinvoicelist.component';
import { StudentreportComponent } from './studentreport/studentreport.component';
import { PaymentsuccessComponent } from './paymentsuccess/paymentsuccess.component';
import { PackageInvDownloadComponent } from './package-inv-download/package-inv-download.component';
import { StudentrankreportComponent } from './studentrankreport/studentrankreport.component';
import { StudentStructureReportComponent } from './student-structure-report/student-structure-report.component';
import { GroupmembersComponent } from './groupmembers/groupmembers.component';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';

import { VjobfulllistComponent } from './vjobfulllist/vjobfulllist.component';
import { TopperstalkComponent } from './topperstalk/topperstalk.component';
import { ToppersdetailComponent } from './toppersdetail/toppersdetail.component';
import { AddtoppersdetailComponent } from './addtoppersdetail/addtoppersdetail.component';
import { MatStepperModule, MatInputModule, MatButtonModule, MatAutocompleteModule,MatSelectModule,MatSnackBarModule,MatDatepickerModule,MatNativeDateModule,MatPaginatorModule} from '@angular/material';
import { JobannouncementlistComponent } from './jobannouncementlist/jobannouncementlist.component';
import { OnlineMcqModule } from '../online-mcq/online-mcq.module';
import { EcommerceModule } from '../ecommerce/ecommerce.module';
import { EvaluateAnswerUploadComponent } from './evaluate-answer-upload/evaluate-answer-upload.component';



@NgModule({
	imports: [
        FormsModule,
        ReactiveFormsModule,
        NgbModalModule.forRoot(),
        CalendarModule.forRoot(),
        CommonModule,
        QuillModule,
        DragulaModule,
        RouterModule.forChild(HomeRoutes),
        FileUploadModule,
        CKEditorModule,TagInputModule,
        NgbModule,
        DxRangeSliderModule,
        DxNumberBoxModule,
        AgmCoreModule.forRoot({
                apiKey: 'AIzaSyDTf9SMP50mRW_dRwPgxnQbAyiIgKIoUBY',
                libraries: ["places"]
              }),
        NgxPermissionsModule.forChild(),
        BarRatingModule,
        JwSocialButtonsModule,
        MatStepperModule,
        MatInputModule,
        MatButtonModule,
        MatAutocompleteModule, 
        MatSelectModule,
        MatSnackBarModule,
        OnlineMcqModule,
        EcommerceModule,
        MatPaginatorModule,
	MatDatepickerModule,
        MatNativeDateModule,
      ],
	declarations: [
        UprofileComponent,
        LandingComponent,
        VprofileComponent,
        ChallengeForumComponent,
        MyAttendanceComponent,
        ReportComponent,
        AddFolderComponent,
        PageComponent,
        UnotificationComponent,
        UannouncementComponent,
        UcalendarComponent,
        ACalendarComponent,
        ForumComponent,
        sanitizeHtmlPipe,
        ForumdetailComponent,
        RightSidebarComponent,
        AnnouncementlistComponent,
        FollowerlistComponent,
        TopicdetailComponent,
        RightSidebar2Component,
        FreedownloadComponent,
        VpgComponent,
        VpgdetailComponent,
        VerificationComponent,        
        PopulartopicComponent,
        TrandingtopicComponent,
        BlogComponent,
        BloglistComponent,
        GroupComponent,
        GroupRightSidebarComponent,
        GroupdetailComponent,        
        VjobComponent,
        VjobdetailComponent ,
        UserinfoComponent,
        DiscoverpeopleComponent,
        ForumaddComponent,
        TrandingpgComponent,        
        AdvertisementForumComponent,        
        TrandingpgComponent,
        ExamsolutionComponent,
        UserBookmarksComponent,
        TestingComponent,
        MmetatagComponent,
        ProfileComponent,
        OtopicdetailComponent,
        RankPredictorComponent,
        SetnewpasswordComponent,
        VfaqComponent,
        ProfileHeadComponent,
        TopicFollowComponent,
        FollowersComponent,
        FollowingComponent,        
        PackagelistComponent,
        PackagedetailComponent,
        StudentPaymentFormComponent,
        MypackagesComponent,
        MypackagedetailComponent,
        PackagedataComponent,
        PaymentComponent,
        QuestionnaireComponent,        
        PackageinvoiceComponent,
        TimelineComponent,
        EvaluateAnswerSheetComponent,
        PackageinvoicelistComponent,
        StudentreportComponent,        
        PaymentsuccessComponent, PackageInvDownloadComponent, StudentrankreportComponent, StudentStructureReportComponent, GroupmembersComponent, HelpdeskComponent,VjobfulllistComponent,JobannouncementlistComponent, AddtoppersdetailComponent, ToppersdetailComponent, TopperstalkComponent,EvaluateAnswerUploadComponent     
        ],
        providers:[GoogleMapsAPIWrapper],
        bootstrap: [VpgComponent],
        exports: [ sanitizeHtmlPipe,ForumComponent,PackageInvDownloadComponent ],
        
})
export class HomeModule {



 }
 //platformBrowserDynamic().bootstrapModule(HomeModule);


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/home.module.ts